<template>
    <footer class="sticky-footer ">
      
    </footer>
</template>

<script>
export default {}
</script>
<style>
.fixed-bottom {
    bottom: 0;
    width: 100%;
    z-index: 1;
}

.small {
    font-size: 0.9em;
}
</style>